import React, { JSX } from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import {
  RadioButtonOption,
  RadioButtonSelector,
} from '~/src/dash/components/radio/RadioButtonSelector';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';

interface IProps {
  selectedValue: string;
  labelWidth: number;
  labelHeight: number;
  handleDatasetChange: (value: string) => void;
  datasets: RadioButtonOption[];
}

export const AuctionInsightsDatasets = ({
  labelWidth,
  labelHeight,
  selectedValue,
  handleDatasetChange,
  datasets,
}: IProps): JSX.Element => {
  return (
    <Cols gap={spacing.base} style={{ alignItems: 'center', height: `${labelHeight}px` }}>
      {/* LABEL */}
      <Col style={{ minWidth: `${labelWidth}px` }}>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='funnel' small />
          </Col>
          <Col>
            <Text small bold tKey='Dataset' singleLineLabel />
          </Col>
        </Cols>
      </Col>
      {/* Datasets */}
      <Col>
        <RadioButtonSelector
          options={datasets}
          onChange={handleDatasetChange}
          selectedValue={selectedValue}
        />
      </Col>
    </Cols>
  );
};
